import OkrPerformance from './OkrPerformance';

const OkrPerformanceConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/okrPerformance',
            element: <OkrPerformance />,
        },
    ],
};

export default OkrPerformanceConfig;
